module.exports = __webpack_public_path__ + "img/2374782-02-0.376d39d9.png";